import { BottomSheet } from '@altify/components';
import { Dialog } from 'components/Dialog/Dialog';
import useBreakpoint from 'hooks/useBreakpoint';
import { ReactNode } from 'react';

type SheetDetent = 'full-height' | 'content-height';

export function DialogOrBottomSheet({
  children,
  onClose,
  snapPoints,
  isOpen = true,
  backgroundColor = '#0C1C2C',
  dismissable = true,
  initialSnapPosition = 0,
  footerContent,
  blurEnabled = false,
  isAuthenticated = true,
  detent = 'content-height',
}: {
  children: ReactNode;
  onClose?: () => void;
  snapPoints?: number[];
  isOpen?: boolean;
  backgroundColor?: string;
  dismissable?: boolean;
  initialSnapPosition?: number;
  footerContent?: ReactNode;
  blurEnabled?: boolean;
  //the reason we need this is for when we use the dialog in the unauthenticated flow where the side menu is not present
  isAuthenticated?: boolean;
  detent?: SheetDetent;
}) {
  const { isSmaller } = useBreakpoint();
  const isDeviceMobile = isSmaller('sm');

  const handleClose = () => {
    if (dismissable) onClose?.();
  };

  return isDeviceMobile ? (
    <BottomSheet
      isOpen={isOpen}
      onClose={handleClose}
      snapPoints={snapPoints}
      backgroundColor={backgroundColor}
      blurEnabled={blurEnabled}
      dismissable={dismissable}
      footerContent={footerContent}
      initialSnapPosition={initialSnapPosition}
      detent={detent}>
      <div className="max-h-screen flex flex-col z-50">{children}</div>
    </BottomSheet>
  ) : (
    <Dialog
      isAuthenticated={isAuthenticated}
      backgroundColor={backgroundColor}
      blurEnabled={blurEnabled}
      dismissable={dismissable}
      isOpen={isOpen}
      onClose={handleClose}>
      {children}
      {footerContent}
    </Dialog>
  );
}
